module.exports = __webpack_public_path__ + "img/20685856.4712a200.png";